<template>
	<div  v-on:click="handleClickEvent()" class="border bg-white shadow-lg mb-10 p-0 shadow-lg flex-1 text-theme-secondary-200 cursor-pointer" id="ChartWrapper" :style="styleObject">
		<div class="flex flex-row items-center px-3 mt-3">
			
			<div class="mr-2 opacity-50 mt-1 ">
				<slot>
					<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" viewBox="0 0 48 48" height="40" width="40"><g transform="matrix(2,0,0,2,0,0)"><path d="M 20.991,11.986c0-0.138,0.112-0.25,0.25-0.25s0.25,0.112,0.25,0.25l0,0c0,0.138-0.112,0.25-0.25,0.25 S20.991,12.124,20.991,11.986 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 20.991,11.986L20.991,11.986 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 17.294,11.986c0-0.138,0.112-0.25,0.25-0.25s0.25,0.112,0.25,0.25 s-0.112,0.25-0.25,0.25S17.294,12.124,17.294,11.986 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 13.6,11.986c0-0.138,0.112-0.25,0.25-0.25s0.25,0.112,0.25,0.25 s-0.112,0.25-0.25,0.25S13.6,12.124,13.6,11.986 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 9.9,11.986c0-0.138,0.112-0.25,0.25-0.25s0.25,0.112,0.25,0.25l0,0 c0,0.138-0.112,0.25-0.25,0.25S9.9,12.124,9.9,11.986 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 9.901,11.986L9.901,11.986 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 13.6,15.682c0-0.138,0.112-0.25,0.25-0.25 s0.25,0.112,0.25,0.25s-0.112,0.25-0.25,0.25S13.6,15.82,13.6,15.682 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 9.9,15.682c0-0.138,0.112-0.25,0.25-0.25 s0.25,0.112,0.25,0.25s-0.112,0.25-0.25,0.25S9.9,15.82,9.9,15.682 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 13.6,19.38c-0.001-0.138,0.111-0.25,0.249-0.251 s0.25,0.111,0.251,0.249s-0.111,0.25-0.249,0.251c0,0-0.001,0-0.001,0C13.712,19.629,13.601,19.518,13.6,19.38 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 9.9,19.38 c-0.001-0.138,0.111-0.25,0.249-0.251s0.25,0.111,0.251,0.249s-0.111,0.25-0.249,0.251c0,0-0.001,0-0.001,0 c-0.138,0.001-0.249-0.11-0.25-0.248C9.9,19.381,9.9,19.38,9.9,19.38 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 13.6,23.076c0-0.138,0.112-0.25,0.25-0.25 s0.25,0.112,0.25,0.25s-0.112,0.25-0.25,0.25S13.6,23.214,13.6,23.076 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 9.9,23.076c0-0.138,0.112-0.25,0.25-0.25 s0.25,0.112,0.25,0.25l0,0c0,0.138-0.112,0.25-0.25,0.25S9.9,23.214,9.9,23.076 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 9.901,23.076L9.901,23.076 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 6.2,11.986 c0-0.138,0.112-0.25,0.25-0.25s0.25,0.112,0.25,0.25l0,0c0,0.138-0.112,0.25-0.25,0.25S6.2,12.124,6.2,11.986 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 6.204,11.986 L6.204,11.986 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 17.294,8.29c0-0.138,0.112-0.25,0.25-0.25s0.25,0.112,0.25,0.25c0,0.138-0.111,0.249-0.249,0.25 c-0.138,0.001-0.25-0.111-0.251-0.249C17.294,8.291,17.294,8.29,17.294,8.29 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 13.6,8.29c0-0.138,0.112-0.25,0.25-0.25 s0.25,0.112,0.25,0.25s-0.112,0.25-0.25,0.25S13.6,8.428,13.6,8.29 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 9.9,8.29c0-0.138,0.112-0.25,0.25-0.25s0.25,0.112,0.25,0.25 s-0.112,0.25-0.25,0.25S9.9,8.428,9.9,8.29 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 9.9,4.592c0-0.138,0.112-0.25,0.25-0.25s0.25,0.112,0.25,0.25s-0.112,0.25-0.25,0.25 S9.9,4.73,9.9,4.592 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 11.75,0.924c0-0.138,0.112-0.25,0.25-0.25s0.25,0.112,0.25,0.25s-0.112,0.25-0.25,0.25 c-0.138,0.001-0.249-0.11-0.25-0.248C11.75,0.925,11.75,0.925,11.75,0.924 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 13.6,4.592c0-0.138,0.112-0.25,0.25-0.25 s0.25,0.112,0.25,0.25s-0.112,0.25-0.25,0.25c-0.138,0.001-0.249-0.11-0.25-0.248C13.6,4.593,13.6,4.593,13.6,4.592 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 6.205,8.29 c0-0.138,0.112-0.25,0.25-0.25s0.25,0.112,0.25,0.25s-0.112,0.25-0.25,0.25c-0.138,0.001-0.249-0.11-0.25-0.248 C6.205,8.291,6.205,8.291,6.205,8.29 " stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 2.508,11.986c0-0.138,0.112-0.25,0.25-0.25s0.25,0.112,0.25,0.25s-0.112,0.25-0.25,0.25 S2.508,12.124,2.508,11.986" stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>
				</slot>
			</div>
			
			<div class="flex flex-col justify-end leading-none ">
				<span class="total-count .. text-4xl mb-1 font-semibold flex flex-row">{{ data.totalCount }}</span>
				<span class="title .. text-md font-semibold opacity-50">{{label}}</span>
			</div>
		</div>
		<canvas class="w-full" id="Chart"></canvas>
	</div>
</template>


<style type="text/css">
#ChartWrapper:hover {color: var(--color-darken)}
#ChartWrapper svg{color: var(--color-darken)}
</style>


<script>

import Chart from 'chart.js'
// import 'chartjs-plugin-annotation'
import moment from 'moment'

export default {
	data() {
		return {
			totalCounter: 1,
			lines: [],
			data: {
				totalCount: '#',
				labels: ['1', '2' , '3', '4', '5'],
				values: [100,200,380, 400 ,420],
			}
		}
	},
	props: ['label','json','color','stacked','route'],
	mounted: function() {

		if( this.json )	this.data  = JSON.parse(this.json);

		this.lines.push({
			type: 'line',
			mode: 'vertical',
			scaleID: 'x-axis-0',
			value: '2019-04-10',
			borderColor: 'black',
			borderWidth: 2,
			label: {
				content: 'Annotatie',
				enabled: true
			},
			onClick: function(e) {
				console.log('Annotation', e.type, this);
			}
		})

		var config = {
			type: 'line',
			data: {
				labels:  this.data.labels,
				datasets: [{
					fill: true,
					spanGaps: true,
					backgroundColor: this.shadeColor( this.color, 0),
					borderColor: this.shadeColor( this.color, -30),
					borderWidth: 4,
					pointRadius: 3,
					pointHoverRadius: 5,
					pointHoverBackgroundColor: this.shadeColor( this.color, -30),
					pointBorderColor: this.shadeColor( this.color, -30),
					pointBackgroundColor: this.shadeColor( this.color, -30),
					data:  this.stacked ? this.data.totals : this.data.values,
				}]
			},

			options: {
				responsive: true,
				circumference:  Math.PI,
				rotation: - Math.PI,
				animation: {
					animateScale: true,
					animateRotate: true
				},
				scales: {
					xAxes: [{
					ticks: {
							display: false,
						},
						gridLines: {
							display: false
						}
					}],
					yAxes: [{
						ticks: {
							display: false,
						},
						gridLines: {
							display: false
						}
					}]
				},
				legend: {
					display: false
				},
				layout: {
					padding: {
						left: -10,
						right: 0,
						top: 15,
						bottom: -20
					}
				},
				annotation: {
					events: ["click"],
					annotations: this.lines,
				}
			},

		};
		var ctx =  this.$el.querySelector('#Chart').getContext('2d');
		window.myLine = new Chart(ctx, config);

	},

	computed: {
		styleObject() {
			return {
				'--color-darken': this.shadeColor( this.color, -30)
			};
		},
	},

	methods: { 

		newDate: function(dateString) {
			return moment(dateString).format('YYYY-MM-DD');
		},

		shadeColor: function(color, amount) {
			return '#' + color.replace(/^#/, '').replace(/../g, color => ('0'+Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
		},

		handleClickEvent(){
			window.location.href = this.route;
		}


	}
}
</script>